// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"93bfc671","635":"482623d1","703":"d6062fdf","787":"6ff1b161"}[chunkId] + ".chunk.js";
};